import { lazySetPersistedAddin, PersistedAddinCommand } from 'owa-addins-core';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { logUsage } from 'owa-analytics';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

interface PinnedAddin {
    id: string;
    controlId: string;
}

enum AddinType {
    None = 0,
    Compose = 1,
    Read = 2,
}

const addinTypesToStrings = {
    [AddinType.None]: 'NoAddins',
    [AddinType.Compose]: 'ComposeAddinOnly',
    [AddinType.Read]: 'ReadAddinOnly',
    [AddinType.Compose | AddinType.Read]: 'BothAddins',
};

function convertToPersistedAddinCommand(pinnedAddin: string): PersistedAddinCommand {
    const parsedPinnedAddin: PinnedAddin = JSON.parse(pinnedAddin);
    return <PersistedAddinCommand>{
        addinId: parsedPinnedAddin.id,
        commandId: parsedPinnedAddin.controlId,
    };
}

export default async function migratePersistedAddins(): Promise<void> {
    const viewStateConfiguration = getUserConfiguration().ViewStateConfiguration;
    const setPersistedAddin = await lazySetPersistedAddin.import();

    let addinTypes = AddinType.None;

    const pinnedComposeAddin: string = viewStateConfiguration.PinnedComposeAddin;
    if (pinnedComposeAddin) {
        const persistedComposeAddinCommand = convertToPersistedAddinCommand(pinnedComposeAddin);
        setPersistedAddin(ExtensibilityModeEnum.MessageCompose, persistedComposeAddinCommand);
        addinTypes |= AddinType.Compose;
    }

    const pinnedReadAddin: string = viewStateConfiguration.PinnedReadAddin;
    if (pinnedReadAddin) {
        const persistedReadAddinCommand = convertToPersistedAddinCommand(pinnedReadAddin);
        setPersistedAddin(ExtensibilityModeEnum.MessageRead, persistedReadAddinCommand);
        addinTypes |= AddinType.Read;
    }

    logUsage('ExtPersistedAddinMigration', [addinTypesToStrings[addinTypes]]);
}
